import { Reacao } from './api/reacao';

export class Reaction {
  liked: boolean;

  constructor(reacao?: Reacao) {
    this.liked = reacao?.curtida || false;
  }
}
